import axiosInstance from "../utils/axios";

export const GetChangePasswordBanner = async (values) => {
    return await axiosInstance().post("admin/change-password", values)
}

